import React from 'react';

// animations
import Fade from "react-reveal/Fade";

const ModuleTitle = ({title}) => {
    return (
        <Fade up>
            <h1 className="common-component-title">{title}</h1>
        </Fade>
    );
};

export default ModuleTitle;